var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stats progesso-leilao"},[_c('div',{staticClass:"mtab"},[_c('div',{staticClass:"title"},[_vm._v("Progresso do Leilão")]),(_vm.controlador.leilao)?_c('leilao-tempo-stats',{attrs:{"full":"","leilao":_vm.controlador.leilao,"lote":_vm.controlador.lote}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }